import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ChevronRight, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { type Appointment } from 'types/appointments';
import { type LocationState } from './types';

interface EditAppointmentProps {
  appointment: Appointment;
  onSuccess: (state: LocationState) => void;
}

export const EditAppointmentDialog = ({
  appointment,
  onSuccess,
}: EditAppointmentProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  const isEditEnabled = !appointment.immovable;

  const handleEditAppointment = (): void => {
    onSuccess({
      appointment,
      psychologist: appointment.psychologist?.psychologist,
      patientId: appointment.patientId,
      flow: FLOW_MODES.edit,
    });
  };

  if (!isEditEnabled) {
    return (
      <Dialog
        className="w-3xl"
        open
        title={t('EditSessionDialog.disabled.heading')}
        description={t('EditSessionDialog.disabled.body')}
      />
    );
  }

  return (
    <Dialog
      className="w-3xl"
      open
      enableOutsideClick={false}
      title={t('EditSessionDialog.heading')}
      secondaryAction={{
        label: (
          <>
            <X className="size-4" />
            {t('EditSessionDialog.cancel')}
          </>
        ),
        variant: 'destructive_terciary',
        size: 'lg',
        icon: 'leading',
      }}
      primaryAction={{
        label: (
          <>
            {t('EditSessionDialog.confirm')}
            <ChevronRight className="size-4" />
          </>
        ),
        action: handleEditAppointment,
        variant: 'secondary',
        size: 'lg',
        className: 'gap-2',
      }}
    >
      <p className="text-sm text-gray-600">{t('EditSessionDialog.body')}</p>
    </Dialog>
  );
};
